/**
 * 日视图和周视图的时间线
 */

import { size } from "lodash";
import React from "react";
import dayjs from "dayjs";
import "./index.less";

function getTileSplit (hour = 1, minute = 60) {
  const timeSplit = [];
  for (let i = 1; i < 24; i += hour) {
    for (let j = 0; j < 60; j += minute) {
      let time = `${i}:${j === 0 ? "00" : j}`;
      timeSplit.push(time);
    }
  }
  return timeSplit;
}

function TimeLable ({
  current = dayjs(),
  currentTimeObj = {
    curtime: dayjs(),
    top: 0
  }
}: {
  current: dayjs.Dayjs;
  currentTimeObj: {
    curtime: dayjs.Dayjs;
    top: number;
  };
}
) {
  const timeSplit = getTileSplit();
  return (
    <div className="calendar-busyidle-timelabel">
      <div key={0} className="calendar-busyidle-timelabel-firstItem" />
      {timeSplit.map((t) => {
        return (
          <div key={t} className="calendar-busyidle-timelabel-item">
            <div className="item-timeLabel">
              {!currentTimeObj.curtime.isBetween(
                dayjs(dayjs().format("YYYY-MM-DD") + " " + t).subtract(16, "minute"),
                dayjs(dayjs().format("YYYY-MM-DD") + " " + t).add(16, "minute"),
                "minute"
              ) || !currentTimeObj.curtime.isSame(current, "day")
                ? t
                : ""}
            </div>
          </div>
        );
      })}
      {currentTimeObj.curtime.isSame(current, "day") && (
        <div
          className="calendar-busyidle-timelabel-currenttime"
          style={{
            // 减去文字高度的一半6 居中
            top: currentTimeObj.top - 6 + "px"
          }}
        >
          {currentTimeObj.curtime.format("HH:mm")}
        </div>
      )}
      <div key={24} className="calendar-busyidle-timelabel-bottomItem" />
    </div>
  );
}
export const TimeLableComponent = React.memo(TimeLable);

function TimeLine () {
  const timeSplit = getTileSplit();
  return (
    <div className="calendar-busyidle-timeline">
      <div key={0} className="calendar-busyidle-timeline-firstItem" />
      {timeSplit.map((t) => {
        return (
          <div key={t} className="calendar-busyidle-timeline-item">
            <div className="item-divider" />
          </div>
        );
      })}
      <div key={24} className="calendar-busyidle-timeline-bottomItem" />
    </div>
  );
}
export const TimeLineComponent = React.memo(TimeLine);
